import { render, staticRenderFns } from "./myDoc.vue?vue&type=template&id=3b863e5b&scoped=true&"
import script from "./myDoc.vue?vue&type=script&lang=js&"
export * from "./myDoc.vue?vue&type=script&lang=js&"
import style0 from "./myDoc.vue?vue&type=style&index=0&id=3b863e5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b863e5b",
  null
  
)

export default component.exports